<div class="heading">
    <div class="button-wrapper">
        <button class="btn hvr-grow has-margin-right" (click)="exportFinanceFeeReport()"> 
            Esporta<i class="ml-10 fas fa-file-excel"></i>
        </button>
    </div>
</div>

<section class="main-content wrapper content-padding scroll-delivery">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="financeFeesFilterForm" (ngSubmit)="filter()" *ngIf="financeFeesFilterForm">

            <div class="item center data-col-">
                <h4 class="title">STATO</h4>
                <span class="data">
                <select formControlName="Delivery.status">
                    <option value="">Tutti</option>
                    <option *ngFor="let dSActive of deliveryStatusAux['forFinance']" [value]="dSActive">
                        {{deliveryStatusAux.ln('it', dSActive)}}
                    </option>
                </select>
                </span>
            </div>

            <!--
            <div class="item data-col-5">
                <h4 class="title">PLATFORM</h4>
                <span class="data">
                <select formControlName="Sale.platform" style="width: 120px;">
                    <option value="">Tutti</option>
                    <option value="shopifysale">Deluxy</option>
                    <option value="cakesales">Cakes</option>
                    <option value="flowerssales">Flowers</option>
                    <option value="businesssales">Business</option>
                </select>
                </span>
            </div>
            -->

            <div class="item data-col-">
                <h4 class="title" (click)="navigateOrder('Delivery.ddtNumber')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.ddtNumber')"></i>
                    ID VENDITA
                </h4>
                <span class="data">
                    <input type="text" formControlName="Delivery.ddtNumber" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title" (click)="navigateOrder('Delivery.id')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.id')"></i>
                    ID CONSEGNE
                </h4>
                <span class="data">
                    <input type="number" formControlName="Delivery.id" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title" (click)="navigateOrder('Delivery.deliveryDate')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.deliveryDate')"></i>
                    DATA CONSEGNA
                </h4>
                <span class="data">
                    <div class="date">Da: </div>
                    <input class="date" type="date" formControlName="Delivery.deliveryDate_from">
                </span>
                <span class="data">
                    <div class="date">A: </div>
                    <input class="date" type="date" formControlName="Delivery.deliveryDate_to">
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title" (click)="navigateOrder(['Product.name'])">
                    <i class="sort-icon fas" [ngClass]="orderIcon(['Product.name'])"></i>
                    PRODOTTO
                </h4>
                <span class="data">
                    <input type="text" formControlName="Product.name" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title" (click)="navigateOrder(['ProductCategory.categoryName'])">
                    <i class="sort-icon fas" [ngClass]="orderIcon(['ProductCategory.categoryName'])"></i>
                    CATEGORIA
                </h4>
                <span class="data">
                    <input type="text" formControlName="ProductCategory.categoryName" >
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    VALORE VENDITE
                </h4>
                <span class="data">
                    <select style="width: 40px;" [(ngModel)]="filters.valoreVendite.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.valoreVendite.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                    <!-- <input type="number" formControlName="Delivery.customFilter" min="1000" max="10000" > -->
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    PREZZO PUBBLICO
                </h4>
                <span class="data">
                    <select style="width: 40px;" [(ngModel)]="filters.prezzoPubblico.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.prezzoPubblico.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('Delivery.id')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.id')"></i>
                    CONSEGNA PREZZO
                </h4>
                <span class="data">
                    <select style="width: 40px;" [(ngModel)]="filters.consegnaPrezzo.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()">
                        <option value="=">=</option>        
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.consegnaPrezzo.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-" >
                <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                    PARTNER
                </h4>
                <span class="data">
                    <input type="text" formControlName="Partner.businessName" >
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('Product.price')">
                    <i class="sort-icon fas fa-sort" [ngClass]="orderIcon('Product.price')"></i>
                    PREZZO PARTNER
                </h4>
                <span class="data">
                    <select [(ngModel)]="filters.prezzoPartner.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input style="width: 100px;" type="number" [(ngModel)]="filters.prezzoPartner.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title" (click)="navigateOrder('PartnerService.price')">
                    <i class="sort-icon fas fa-sort" [ngClass]="orderIcon('PartnerService.price')"></i>
                    FEE %
                </h4>
                <span class="data">
                    <select formControlName="PartnerService.price.operator" style="width: 40px;">
                        <option value="equal">=</option>    
                        <option value="lessThan"><</option>
                        <option value="moreThan">></option>
                        <option value="moreThanOrEqual">>=</option>
                        <option value="lessThanOrEqual"><=</option>
                    </select>
                    <input type="number" style="width: 100px;" formControlName="PartnerService.price" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    FEE VALUE
                </h4>
                <span class="data">    
                    <select [(ngModel)]="filters.feeValue.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input style="width: 100px;" type="number" [(ngModel)]="filters.feeValue.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    FEE + IVA
                </h4>
                <span class="data">
                    <select [(ngModel)]="filters.feeValueWithIva.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                        </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.feeValueWithIva.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    COSTO CONSEGNA
                </h4>
                <span class="data">
                    <select [(ngModel)]="filters.costoConsegna.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.costoConsegna.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    PRIMO MARGINE
                </h4>
                <span class="data">
                    <select [(ngModel)]="filters.primoMargine.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.primoMargine.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    PRIMO MARGINE %
                </h4>
                <span class="data">
                    <select [(ngModel)]="filters.primoMarginePercentage.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.primoMarginePercentage.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    CORRISPETTIVO
                </h4>
                <span class="data">
                    <select [(ngModel)]="filters.corrispettivo.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.corrispettivo.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    IVA
                </h4>
                <span class="data">
                    <select [(ngModel)]="filters.iva.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.iva.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    COMMISSIONE INCASSI
                </h4>
                <span class="data">
                    <select [(ngModel)]="filters.commissioneIncassi.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.commissioneIncassi.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    MARGINE TOTALE
                </h4>
                <span class="data">
                    <select [(ngModel)]="filters.margineTotale.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.margineTotale.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    MARGINE TOTALE %
                </h4>
                <span class="data">`
                    <select [(ngModel)]="filters.margineTotalePercentage.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.margineTotalePercentage.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-" style="display: none;">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    % NETTO SENZA IVA
                </h4>
                <span class="data">
                    <select [(ngModel)]="filters.nettaSenzIva.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.nettaSenzIva.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    INCASSO PARTNER
                </h4>
                <span class="data">
                    <select [(ngModel)]="filters.incassoPartner.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.incassoPartner.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item nowrap">
                <h4 class="title hide-on-mobile">AZIONI</h4>
                <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                    RICERCA <i class="fas fa-search"></i>
                </button>
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); resetFilter();">
                    RESET <i class="fas fa-times-circle"></i>
                </button>
                </span>
            </div>

        </form>

        <div class="table-row-container row" *ngFor="let delivery of flattenedDeliveries" [ngClass]="{'parent-total-row': delivery?.isTotalRow}">

            <ng-container *ngIf="delivery?.isTotalRow">

                <div class="item left-space data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title">STATO :</h4>
                        <span class="status-service-image">
                            <img class="service-img" [src]="showServiceDetails(delivery)?.service?.image" width="50" height="50" *ngIf="showServiceDetails(delivery)?.service?.image">
                            <a [routerLink]="getDeliveryLink(delivery?.id, delivery?.deluxyDelivery)" [ngClass]="delivery?.status == 'delivering' ? 'blink' : ''">
                            <span class="dataGesture">
                                <span [matTooltip]="deliveryStatusAux.ln('it', delivery?.status)" class="status {{deliveryStatusAux.css(delivery?.status)}}"></span>
                            </span>
                            </a>
                        </span>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">ID VENDITA:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ 
                                ( delivery?.orderId && delivery?.externalOrderSource ) 
                                    ? 'M' + delivery?.orderId
                                    : ( delivery?.orderId && !delivery?.externalOrderSource ) 
                                    ? (delivery?.orderId | saleName: delivery?.shop)
                                    : (delivery?.ddtNumber && !delivery?.orderId && !delivery?.externalOrderSource ) 
                                    ? delivery?.ddtNumber
                                    : '---'
                            }}
                        </a>
                    </span>
                </div>
                
                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">ID CONSEGNE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{delivery.id}}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title dataGesture">DATA CONSEGNA:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ delivery?.deliveryDate | date:'fullDate' | titlecase }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PRODOTTO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}"> </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">CATEGORIA :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}"> </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">VALORE VENDITE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentValoreVendite | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PREZZO PUBBLICO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentPrezzoPubblico | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">CONSEGNA PREZZO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentConsegnaPrezzo | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PARTNER :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}"> </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PREZZO PARTNER :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}"> 
                            {{ showTotalOfParentRow(delivery)?.parentPrezzoPartner | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">FEE % :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentFeePercentage }}%
                        </a>
                    </span>
                </div>
                
                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">FEE VALUE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentFeeValue | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">FEE + IVA :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentFeeValueWithIva | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">COSTO CONSEGNA :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentDeliveryCost | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PRIMO MARGINE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentPrimoMargine | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PRIMO MARGINE %:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentPrimoMarginePercentage }}%
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">CORRISPETTIVO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentCorrispettivo | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">IVA :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentIva | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">COMMISSIONE INCASSI :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentCommissioneIncassi | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">MARGINE TOTALE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentMargineTotale | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">MARGINE TOTALE %:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentMargineTotalePercentage }}%
                        </a>
                    </span>
                </div>

                <div class="item data-col-" style="display: none;">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">% NETTO SENZA IVA :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentNettaSenzIva }}%
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">INCASSO PARTNER :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': showTotalOfParentRow(delivery)?.parentMargineTotale <= 0}">
                            {{ showTotalOfParentRow(delivery)?.parentPartnerCollectionPrice | currency:'EUR' }}
                        </a>
                    </span>
                </div>
            </ng-container>
  

            <ng-container *ngIf="!delivery?.isTotalRow">

                <div class="item left-space data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title">STATO :</h4>
                        <span class="status-service-image">
                            <img class="service-img" [src]="showServiceDetails(delivery)?.service?.image" width="50" height="50" *ngIf="showServiceDetails(delivery)?.service?.image">
                            <a [routerLink]="getDeliveryLink(delivery?.id, delivery?.deluxyDelivery)" [ngClass]="delivery?.status == 'delivering' ? 'blink' : ''">
                            <span class="dataGesture">
                                <span [matTooltip]="deliveryStatusAux.ln('it', delivery?.status)" class="status {{deliveryStatusAux.css(delivery?.status)}}"></span>
                            </span>
                            </a>
                        </span>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">ID VENDITA:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            <!-- {{ 
                                (
                                    delivery?.orderId && delivery?.externalOrderSource
                                ) ? 'M' + delivery.orderId
                                    : (
                                        delivery?.orderId && !delivery?.externalOrderSource
                                    ) ? (delivery.orderId | saleName: delivery.shop)
                                    : (
                                        delivery?.ddtNumber && !delivery?.orderId && !delivery?.externalOrderSource
                                    ) ? delivery.ddtNumber
                                        : '---'
                            }} -->
                            {{ 
                                (delivery?.orderId && delivery?.externalOrderSource) 
                                  ? 'M' + delivery.orderId 
                                  : (
                                      delivery?.ddtNumber && !delivery?.externalOrderSource
                                    ) 
                                      ? (delivery.ddtNumber | saleName: delivery.shop : delivery.ddtNumber) 
                                      : '---' 
                            }}                              
                        </a>
                    </span>
                </div>
                
                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">ID CONSEGNE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{delivery.id}}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title dataGesture">DATA CONSEGNA:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ delivery?.deliveryDate | date:'fullDate' | titlecase }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PRODOTTO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            <ng-container *ngIf="delivery?.deliveryProducts && delivery.deliveryProducts.length > 0">
                                <span *ngFor="let product of delivery.deliveryProducts; let last = last">
                                {{ product?.product?.name }}{{ !last ? ', ' : '' }}
                                </span>
                            </ng-container>
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">CATEGORIA :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            <ng-container *ngIf="delivery?.deliveryProducts && delivery.deliveryProducts.length > 0">
                            <span *ngFor="let product of delivery.deliveryProducts; let last = last">
                                {{ product?.product?.productCategory?.categoryName }}{{ !last ? ', ' : '' }}
                            </span>
                            </ng-container>
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">VALORE VENDITE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.valoreVendite | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PREZZO PUBBLICO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.prezzoPubblico | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">CONSEGNA PREZZO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.consegnaPrezzo | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PARTNER :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.partnerName }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PREZZO PARTNER :</h4>
                        <ng-container *ngIf="delivery?.deliveryProducts && delivery.deliveryProducts.length > 0">
                            <span *ngFor="let product of delivery.deliveryProducts; let last = last">
                                <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" 
                                    [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                                    <!-- {{ ((product?.productVariant?.variantPrice || product?.product?.price || 0) * (product?.quantity || 1)) | currency:'EUR':'symbol':'1.2-2' }} -->
                                    {{ calculatePartnerPrice(delivery) | currency:'EUR':'symbol':'1.2-2' }}
                                    {{ !last ? ', ' : '' }}
                                </a>
                            </span>
                        </ng-container>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">FEE % :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.feePercentage }}%
                        </a>
                    </span>
                </div>
                
                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">FEE VALUE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.feeValue | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">FEE + IVA :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.feeValueWithIva | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">COSTO CONSEGNA :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.totalDeliveryCost | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PRIMO MARGINE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.primoMargine | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PRIMO MARGINE %:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.primoMarginePercentage }}%
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">CORRISPETTIVO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.corrispettivo | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">IVA :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.iva | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">COMMISSIONE INCASSI :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.commissioneIncassi | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">MARGINE TOTALE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.margineTotale | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">MARGINE TOTALE %:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.margineTotalePercentage }}%
                        </a>
                    </span>
                </div>

                <div class="item data-col-" style="display: none;" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">% NETTO SENZA IVA :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.nettaSenzIva }}%
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">INCASSO PARTNER :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.partnerCollectionPrice | currency:'EUR' }}
                        </a>
                    </span>
                </div>
            </ng-container>

        </div>

        <div class="table-row-container row total-row" *ngIf="deliveries.length">
            <div class="item data-col-5">
                <span class="data-row-left">
                    <a >
                        <strong>Totale</strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">VALORE VENDITE :</h4> -->
                    <a>
                        <strong>{{ totalValues.totalValoreVendite | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">PREZZO PUBBLICO :</h4> -->
                    <a>
                        <strong>{{ totalValues.totalPrezzoPubblico | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">CONSEGNA PREZZO :</h4> -->
                    <a>
                        <strong>{{ totalValues.totalConsegnaPrezzo | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">PREZZO PARTNER :</h4> -->
                    <a>
                        <strong>{{ totalValues.totalPrezzoPartner | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">FEE % :</h4> -->
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">FEE VALUE :</h4> -->
                    <a>
                        <strong>{{ totalValues.totalFeeValue | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">FEE + IVA :</h4> -->
                    <a>
                        <strong>{{ totalValues.totalFeeValueWithIva | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">COSTO CONSEGNA :</h4> -->
                    <a>
                        <strong>{{ totalValues.totalDeliveryCost | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">PRIMO MARGINE :</h4> -->
                    <a>
                        <strong>{{ totalValues.totalPrimoMargine | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">PRIMO MARGINE %:</h4> -->
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">CORRISPETTIVO :</h4> -->
                    <a>
                        <strong>{{ totalValues.totalCorrispettivo | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>
          
            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">IVA :</h4> -->
                    <a>
                        <strong>{{ totalValues.totalIva | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>
          
            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">COMMISSIONE INCASSI :</h4> -->
                    <a>
                        <strong>{{ totalValues.totalCommissioneIncassi | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>
          
            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">MARGINE TOTALE :</h4> -->
                    <a>
                        <strong>{{ totalValues.totalMargineTotale | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>
          
            <div class="item data-col-">
                <span class="data-row-left">
                    <!-- <h4 class="title table-title">MARGINE TOTALE %:</h4> -->
                    <a>
                        <strong>{{ totalValues?.totalMarginePercentage?.toFixed(2) }} %</strong>
                    </a>
                </span>
            </div>
          
            <div class="item data-col-" style="display: none;">
              <span class="data-row-left">
                <!-- <h4 class="title table-title">% NETTO SENZA IVA :</h4> -->
                <a>
                    <!-- <strong>{{ totalValues.totalNettaSenzIva }}%</strong> -->
                </a>
              </span>
            </div>
          
            <div class="item data-col-">
              <span class="data-row-left">
                <!-- <h4 class="title table-title">INCASSO PARTNER :</h4> -->
                <a>
                    <strong>{{ totalValues.totalPartnerCollectionPrice | currency:'EUR' }}</strong>
                </a>
              </span>
            </div>
          
        </div>
          
    </div>
</section>